import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isAdminLogin = location.pathname === '/admin-login';
  const isAdminRoute = isAdmin || isAdminLogin;
  
  // Hide navbar on home page, about page, team page, services page, work page, and connect page
  if (location.pathname === '/' || location.pathname === '/about' || location.pathname === '/team' || location.pathname === '/services' || location.pathname === '/work' || location.pathname === '/connect') {
    return null;
  }

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/');
  };

  return null;
};

export default Navbar; 